module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.researchGroupCharacter === 'leader') ? _c('div', {
    staticClass: "research_group_container"
  }, [_c('div', {
    staticClass: "hd research-background-color"
  }, [(!_vm.isWapp) ? _c('span', {
    staticClass: "icon icon-left navshare",
    on: {
      "click": _vm.goBack
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_title"
  }, [_vm._v("注册联系人")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box_1"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "outer_3"
  }, [_c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.registerName),
      expression: "registerName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_name",
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.registerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.registerMobile),
      expression: "registerMobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_mobile",
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.registerMobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerMobile = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticClass: "attr_name"
  }, [_vm._v("邮箱")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.registerEmail),
      expression: "registerEmail",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "id": "search_email",
      "type": "text",
      "placeholder": "请输入邮箱"
    },
    domProps: {
      "value": (_vm.registerEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.registerEmail = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "outer_attr"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "attr_name"
  }, [_vm._v("单位")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_approvetype"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.enterprise.enterpriseName),
      expression: "enterprise.enterpriseName",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input_text",
    attrs: {
      "readonly": "readonly",
      "unselectable": "on",
      "id": "search_enterpriseName",
      "type": "text",
      "placeholder": "请选择单位"
    },
    domProps: {
      "value": (_vm.enterprise.enterpriseName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.enterprise, "enterpriseName", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "block_2"
  }, [_c('label', {
    staticClass: "label-checkbox item-content"
  }, [_c('input', {
    staticClass: "radio-input-attr",
    attrs: {
      "type": "radio",
      "name": "attr_agree",
      "value": ""
    },
    domProps: {
      "checked": _vm.agreeStatus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-media",
    on: {
      "click": function($event) {
        _vm.agreeStatus = !_vm.agreeStatus
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-form-checkbox i-style"
  }), _vm._v(" "), (_vm.agreeStatus) ? _c('span', {
    staticClass: "agreement research-font-color"
  }, [_vm._v("已阅读并同意")]) : _c('span', {
    staticClass: "desc"
  }, [_vm._v("已阅读并同意")])])]), _vm._v(" "), _c('u', {
    staticClass: "agreement research-font-color",
    on: {
      "click": _vm.toggleResearchGroupRemindBox
    }
  }, [_vm._v("《吉凯基因淘基因用户注册协议》")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ft research-background-color",
    on: {
      "click": _vm.register
    }
  }, [_c('span', {
    staticClass: "addMember"
  }, [_vm._v("注册")])])])]), _vm._v(" "), (_vm.showResearchGroupRemindBox) ? _c('ResearchGroupRemindBox', {
    attrs: {
      "remindParams": _vm.remindParams
    },
    on: {
      "toggleShow": _vm.toggleResearchGroupRemindBox
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFirstLevelEnterpriseBox) ? _c('FirstLevelEnterpriseBox', {
    on: {
      "toggleShow": _vm.toggleShowFirstLevelEnterpriseBox,
      "update": _vm.updateFirstLevelEnterprise
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showDepartmentBox) ? _c('DepartmentBox', {
    attrs: {
      "enterpriseNo": _vm.enterprise.enterpriseNo
    },
    on: {
      "toggleShow": _vm.toggleShowDepartmentBox,
      "update": _vm.updateDepartment
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "empty"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a1d858c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchMemberManagement/RegisterContact.vue
// module id = 1555
// module chunks = 8